import React, { useState, useEffect, useRef } from "react";
// import Router from 'react-router';
import { useNavigate } from 'react-router-dom';

import QuestionHeader from "../components/QuestionHeader";
import DisplayBoard from '../components/DisplayBoard';
import AnswerBoard from '../components/AnswerBoard';
import CountDownTimer from "../components/CountDownTimer";

const initQuestionNum = 1;
const totalQuestionNum = 5;
const displayInitKey = 0;
const timerInitKey = 1000;
const nextQuestionTime = 3;
const questionAnswerTime = 30;

const GameplayPage = () => {

  const timerKey = useRef(displayInitKey);
  const displayKey = useRef(timerInitKey);
  const navigate = useNavigate();
  const [isPlaying, setIsPlaying] = useState(false);
  const [duration, setDuration] = useState(questionAnswerTime);
  const [isNextQuestion, setIsNextQuestion] = useState(false);
  const [questionNum, setQuestionNum] = useState(initQuestionNum);
  const [fetchedAnswers, setFetchedAnswers] = useState([]);

  useEffect(() => {
    if (questionNum > initQuestionNum) {
      console.log('[info] increm display & timer key')
      displayKey.current += 1;
      timerKey.current += 1;
      if (questionNum > totalQuestionNum) {
        console.log('[info] go to summary')
        navigate("/summary");
      }
    }
    // temporarily stop isplaying
    setIsPlaying(false);
  }, [questionNum])

  useEffect(() => {
    // if next question is loaded
    if (isNextQuestion) {
      console.log("[info] nextQ, increm timer")
      // increment timer key
      timerKey.current += 1;
      setDuration(nextQuestionTime);
    }
  }, [isNextQuestion]);


  return (
    <div className="gameplay-page">
      <QuestionHeader
        isPlaying={isPlaying}
      />
      <CountDownTimer
        key={timerKey.current}
        duration={duration}
        questionAnswerTime={questionAnswerTime}
        isPlaying={isPlaying}
        setDuration={setDuration}
        setQuestionNum={setQuestionNum}
        setIsNextQuestion={setIsNextQuestion}
      />
      <em className="question-no">{`Question ${questionNum}`}</em>
      <DisplayBoard
        key={displayKey.current}
        isPlaying={isPlaying}
        isNextQuestion={isNextQuestion}
        questionNum={questionNum}
        setFetchedAnswers={setFetchedAnswers}
        setIsPlaying={setIsPlaying}
      />
      {isPlaying ?
        <AnswerBoard
          questionNum={questionNum}
          totalQuestionNum={totalQuestionNum}
          setIsNextQuestion={setIsNextQuestion}
          fetchedAnswers={fetchedAnswers}
        /> : <></>
      }
    </div>
  );
}

export default GameplayPage;